export default __webpack_public_path__ + "static/media/separator1-img5.95a926f6.png";